import React, { useState, useLayoutEffect, useContext } from 'react'
import styled from 'styled-components'
import { BlocksPipes, ContentBlockGallery, Galleries } from '../../../../common/types/api/page'
import { WidgetTypes } from '../../../../common/types/api/report'
import { Recipient } from '../../../../common/types/form'
import { ComponentCardForm } from '../../../../common/types/cardForm'
import LiveSpan from '../LiveSpan'

import { getHTMLPipesRaw } from '../../../../api/getHTMLPipesVariables'

import i18n from 'live/services/i18n'
import { CustomListAsyncStyles, StyledGalleryEditor } from '../../ReportContent/components/GalleryEditor/galleryEditor'

import ListAsync from '../../LookupsList/ListAsync'
import { ReportContext } from '../../../../../src/app'
import { OptionType } from '../../../../common/types/utilities'

import FollowingGlobalSpanIcon from './FollowinGlobalSpanIcon'
import PipesForm from '../../../../common/components/PipesForm'

interface HtmlEditor {
    type: WidgetTypes
    config: BlocksPipes | Galleries
    configProps: any
}
export default function HtmlEditor({ formObject, onChange }: ComponentCardForm<HtmlEditor>): JSX.Element {
    const { config, type, configProps } = formObject
    let configData = config
    if (type === WidgetTypes.GALLERY) {
        const columns = (config as Galleries)?.columns || []
        const colIdx = configProps?.indexColumn
        const rowIdx = configProps?.indexRow
        const row = columns && columns.length > rowIdx ? columns[rowIdx] : []
        const block = row && row.length > colIdx ? row[colIdx] : undefined
        configData = ((block && (block as ContentBlockGallery)?.content) ?? { template: undefined }) as BlocksPipes
    }
    const { template, span, query, unfollowSpan } = configData as BlocksPipes
    const [templateHTML, setTemplateHTML] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(false)

    const { report } = useContext(ReportContext)
    const recipients = report.mailSettings?.recipients || []
    const [previewRecipient, setPreviewRecipient] = useState<Recipient>(recipients[0])

    const updateTemplate = (): void => {
        setLoading(true)
        getHTMLPipesRaw({ blockPipes: configData as BlocksPipes, recipient: previewRecipient })
            .then(html => {
                setTemplateHTML(html)
            })
            .finally(() => {
                setLoading(false)
            })
    }
    useLayoutEffect(() => updateTemplate(), [])

    return (
        <StyledGalleryEditor>
            <Content>
                <section
                    className={'GESettingsSection__Header'}
                    style={{
                        justifyContent: 'flex-start'
                    }}
                >
                    <button disabled={false} onClick={updateTemplate}>
                        <i className={'far fa-redo'}></i>
                        {i18n('Update Preview')}
                    </button>

                    <div
                        style={{
                            width: '300px',
                            padding: '10px'
                        }}
                    >
                        <label>{i18n('Recipient Group to Preview')}</label>
                        <ListAsync<string[]>
                            placeholder={i18n('Select the recipient group')}
                            getApi={function () {
                                return new Promise(resolve => {
                                    resolve(recipients.map(recipient => recipient.name))
                                })
                            }}
                            isClearable={true}
                            isMulti={false}
                            value={{ label: previewRecipient?.name, value: previewRecipient?.name }}
                            onChange={option => {
                                if (!option) {
                                    setPreviewRecipient(undefined)
                                } else {
                                    const firstOption = (option[0] || option) as OptionType
                                    const value = firstOption?.value
                                    const newRecipient = recipients.find(({ name }) => name === value)
                                    if (!newRecipient) {
                                        setPreviewRecipient(undefined)
                                    } else {
                                        setPreviewRecipient(newRecipient)
                                    }
                                }
                            }}
                            callback={names => names.map(name => ({ label: name, value: name }))}
                            disabled={false}
                            editMode={true}
                            styles={CustomListAsyncStyles}
                        />
                    </div>
                </section>
                <PipesForm
                    maxHeight="250px"
                    onChange={expression => {
                        if (type === WidgetTypes.GALLERY) {
                            const gallery = config as Galleries
                            const columns = gallery?.columns || []
                            const colIdx = configProps?.indexColumn
                            const rowIdx = configProps?.indexRow
                            if (
                                columns &&
                                columns.length > rowIdx &&
                                columns[rowIdx] &&
                                columns[rowIdx].length > colIdx &&
                                columns[rowIdx][colIdx]
                            ) {
                                const currentContent = ((columns[rowIdx][colIdx] as ContentBlockGallery).content as BlocksPipes)
                                onChange({
                                    type,
                                    config: {
                                        ...config,
                                        columns: [
                                            ...columns.slice(0, rowIdx),
                                            [
                                                ...columns[rowIdx].slice(0, colIdx),
                                                {
                                                    ...columns[rowIdx][colIdx],
                                                    content: {
                                                        ...currentContent,
                                                        query: expression
                                                    }
                                                },
                                                ...columns[rowIdx].slice(colIdx + 1),
        
                                            ],
                                            ...columns.slice(rowIdx + 1)
                                        ]
                                    },
                                    configProps
                                })
                            }
                        } else {
                            onChange({
                                type,
                                config: {
                                    ...config,
                                    query: expression
                                },
                                configProps
                            })
                        }
                    }}
                    query={query}
                ></PipesForm>
                <Content style={{ flexDirection: 'row' }}>
                    <HtmlContent>
                        <textarea
                            onChange={({ target }) => {
                                if (type === WidgetTypes.GALLERY) {
                                    const gallery = config as Galleries
                                    const columns = gallery?.columns || []
                                    const colIdx = configProps?.indexColumn
                                    const rowIdx = configProps?.indexRow
                                    if (
                                        columns &&
                                        columns.length > rowIdx &&
                                        columns[rowIdx] &&
                                        columns[rowIdx].length > colIdx &&
                                        columns[rowIdx][colIdx]
                                    ) {
                                        ;(
                                            (columns[rowIdx][colIdx] as ContentBlockGallery).content as BlocksPipes
                                        ).template = target.value
                                        onChange({
                                            type,
                                            config: {
                                                ...config,
                                                columns
                                            },
                                            configProps
                                        })
                                    }
                                } else {
                                    onChange({
                                        type,
                                        config: {
                                            ...config,
                                            template: target.value
                                        },
                                        configProps
                                    })
                                }
                            }}
                        >
                            {template}
                        </textarea>
                    </HtmlContent>

                    <Preview>
                        <Span>
                            <div className="liveSpan">
                                <LiveSpan
                                    span={span}
                                    setSpan={span => {
                                        if (type === WidgetTypes.GALLERY) {
                                            const gallery = config as Galleries
                                            const columns = gallery?.columns || []
                                            const colIdx = configProps?.indexColumn
                                            const rowIdx = configProps?.indexRow
                                            if (
                                                columns &&
                                                columns.length > rowIdx &&
                                                columns[rowIdx] &&
                                                columns[rowIdx].length > colIdx &&
                                                columns[rowIdx][colIdx]
                                            ) {
                                                ;(
                                                    (columns[rowIdx][colIdx] as ContentBlockGallery)
                                                        .content as BlocksPipes
                                                ).span = span
                                                onChange({
                                                    type,
                                                    config: {
                                                        ...config,
                                                        columns
                                                    },
                                                    configProps
                                                })
                                            }
                                        } else {
                                            onChange({
                                                type,
                                                config: {
                                                    ...config,
                                                    span
                                                },
                                                configProps
                                            })
                                        }
                                    }}
                                ></LiveSpan>
                            </div>
                            <div className="unfollowIcon">
                                <FollowingGlobalSpanIcon
                                    follow={!unfollowSpan}
                                    onClick={() => {
                                        if (type === WidgetTypes.GALLERY) {
                                            const gallery = config as Galleries
                                            const columns = gallery?.columns || []
                                            const colIdx = configProps?.indexColumn
                                            const rowIdx = configProps?.indexRow
                                            if (
                                                columns &&
                                                columns.length > rowIdx &&
                                                columns[rowIdx] &&
                                                columns[rowIdx].length > colIdx &&
                                                columns[rowIdx][colIdx]
                                            ) {
                                                ;(
                                                    (columns[rowIdx][colIdx] as ContentBlockGallery)
                                                        .content as BlocksPipes
                                                ).unfollowSpan = !unfollowSpan
                                                onChange({
                                                    type,
                                                    config: {
                                                        ...config,
                                                        columns
                                                    },
                                                    configProps
                                                })
                                            }
                                        } else {
                                            onChange({
                                                type,
                                                config: {
                                                    ...config,
                                                    unfollowSpan: !unfollowSpan
                                                },
                                                configProps
                                            })
                                        }
                                    }}
                                />
                            </div>
                        </Span>
                        <div
                            className={'GEPreview'}
                            style={{
                                minHeight: '250px',
                                height: '250px',
                                overflow: 'none'
                            }}
                        >
                            {loading ? (
                                <div className={'GEPreview__Loading'}>
                                    <i className="GEPreview__Loading--Icon fas fa-spinner fa-pulse" />
                                </div>
                            ) : (
                                <span
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        overflowY: 'auto'
                                    }}
                                    dangerouslySetInnerHTML={{ __html: templateHTML }}
                                />
                            )}
                        </div>
                    </Preview>
                </Content>
            </Content>
        </StyledGalleryEditor>
    )
}

const Span = styled.div`
    padding: 5px;
    display: flex;
    .liveSpan {
        width: 300px;
    }
    .unfollowIcon {
        justify-content: center;
        align-items: center;
        align-self: center;
        margin: 10px;
        padding-top: 5px;
    }
`

const Preview = styled.div`
    display: inline;
    width: 50%;
    border-left: solid 1px #c8ccd4;
    flex: 1;
    padding: 5px;
    max-height: 350px;
`
const HtmlContent = styled.div`
    display: inline;
    flex: 1;
    max-height: 350px;

    padding: 5px;
    textarea {
        height: 100%;
        max-height: 340px;
    }
`

const Content = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    min-height: 200px;
    background-color: #eeeeee;
`
